/* RESPONSIBLE TEAM: team-phone */
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { inject as service } from '@ember/service';
import type CustomReportsService from 'embercom/services/custom-reports-service';

export default class CallsRoute extends IntercomRoute {
  @service declare customReportsService: CustomReportsService;

  beforeModel() {
    this.customReportsService.routeToOverviewPage();
  }
}
